import type {AiChatTargetSize} from '@Components/ai-chat-window/ai-chat-window.types';

export enum ButtonActionType {
  DOWNLOAD = 'download',
  DOWNLOAD_DESIGN = 'download_design',
  TURN_INTO_VIDEO = 'turn_into_video',
  USE_THIS = 'useThis',
  FILL_PROMPT = 'fill_prompt',
  UPSELL_PREMIUM = 'upsell_premium',
  UPGRADE_PREMIUM = 'upgrade_premium',
  UPSELL_CREDITS = 'upsell_credits',
}

export enum DownloadFileType {
  JPG = 'jpg',
  PNG = 'png',
  PDF = 'pdf',
}

export const ORIGINAL_SIZE_DOWNLOAD_FILE_TYPES: DownloadFileType[] = [DownloadFileType.PNG, DownloadFileType.PDF];

export const EXACT_SIZE_DOWNLOAD_FILE_TYPES: DownloadFileType[] = [DownloadFileType.JPG, ...ORIGINAL_SIZE_DOWNLOAD_FILE_TYPES];

export enum ImageQualityOption {
  ORIGINAL = 'original',
  ENHANCED_4K = 'enhanced_4k',
}

export enum DownloadImageQuality {
  ORIGINAL = 'original',
  ENHANCED_4K = 'enhanced_4k',
}

export interface DownloadButtonAction {
  type: ButtonActionType.DOWNLOAD;
  chatId: string;
  hashedId: string;
  fileType: DownloadFileType;
  imageQuality: DownloadImageQuality;
  /** Present on an exact-size download, which is the only kind that takes JPG. */
  targetSize?: AiChatTargetSize;
}

export interface DownloadDesignButtonAction {
  type: ButtonActionType.DOWNLOAD_DESIGN;
  chatId: string;
  posterHashedId: string;
  pageHashedId: string | null;
}

export interface TurnIntoVideoButtonAction {
  type: ButtonActionType.TURN_INTO_VIDEO;
  chatId: string;
  hashedId: string;
  /** Names the user's attachment the video belongs under; absent for a generated image, where hashedId names it. */
  attachmentKey?: string;
}

export interface UseThisButtonAction {
  type: ButtonActionType.USE_THIS;
  chatId: string;
  hashedId: string;
}

export interface FillPromptButtonAction {
  type: ButtonActionType.FILL_PROMPT;
  chatId: string;
  text: string;
}

export interface UpsellPremiumButtonAction {
  type: ButtonActionType.UPSELL_PREMIUM;
  chatId: string;
  promoCode?: string;
}

export interface UpgradePremiumButtonAction {
  type: ButtonActionType.UPGRADE_PREMIUM;
  chatId: string;
}

export interface UpsellCreditsButtonAction {
  type: ButtonActionType.UPSELL_CREDITS;
  chatId: string;
}

export type ButtonAction = DownloadButtonAction | DownloadDesignButtonAction | TurnIntoVideoButtonAction | UseThisButtonAction | FillPromptButtonAction | UpsellPremiumButtonAction | UpgradePremiumButtonAction | UpsellCreditsButtonAction;
